import { getRumClient } from "./initializeRum";

interface Identity {
  id: string;
  correlationId?: string;
  organization?: { id: string };
}

const setRumUser = (identity: Identity | null, isImpersonated = false): void => {
  const rumClient = getRumClient();
  if (!rumClient || !identity) {
    return;
  }

  const { id, correlationId, organization } = identity;

  rumClient.addSessionAttributes({
    userId: correlationId || id,
    organizationId: organization?.id ?? "",
    isImpersonated: String(isImpersonated),
  });
};

export default setRumUser;
